export default __webpack_public_path__ + "static/media/264981__renatalmar__sfx-magic.0e0d313d.mp3";